






































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AttributeModel from '@/models/AttributeModel';
import { AttributeTypes } from '@/common/enum';
import carousel from 'vue-owl-carousel';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';
import store from '@/store';
import LazyImage from '@/components/LazyImage.vue';
import { KeyValuePair } from '../models/KeyValuePair';
import eventBus from '@/common/bus';

@Component({
  name: 'Attribute',
  components: {
    carousel,
    LazyImage,
  },
  filters: {
    formatCurrency: (value: number) => {
      return new Intl.NumberFormat('gbp', {
        style: 'currency',
        currency: 'GBP',
      }).format(value || 0);
    },
  },
})
export default class Attribute extends Vue {
  public attributeImageUrl: string = '';
  @Prop({
    default: () => new AttributeModel(),
  })
  public value!: AttributeModel;
  @Prop() private data!: AttributeModel[];
  @Prop() private title!: string;
  private selected: AttributeModel = new AttributeModel();

  private carouselResponsive: Array<
    KeyValuePair<number, Record<string, number>>
  > = [
    {
      key: 0,
      value: { items: 1, stagePadding: 30, margin: 10 },
    },
    {
      key: 500,
      value: { items: 2, stagePadding: 30, margin: 10 },
    },
    {
      key: 700,
      value: { items: 3 },
    },
    {
      key: 1000,
      value: { items: 4 },
    },
  ];
  private windowWidth: number = 0;

  private get carouselResponsiveProp(): Record<number, Record<string, number>> {
    const items: Record<number, Record<string, number>> = {};
    this.carouselResponsive.forEach((r) => {
      items[r.key] = r.value;
    });
    return items;
  }

  private get showNext(): boolean {
    const list = this.carouselResponsive.filter(
      (r) => r.key < this.windowWidth,
    );
    const last = list[list.length > 0 ? list.length - 1 : 0];
    return this.data.length > last.value.items;
  }

  @Watch('value')
  protected updateInternalStore() {
    this.selected = this.value;
  }

  @Watch('data', { deep: true })
  private onDataChange() {
    if (this.data.length === 1) {
      this.$nextTick(() => {
        this.activate(this.data[0]);
      });
    }
  }

  private created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  private mounted() {
    this.updateInternalStore();

    const storeModule = getModule(StoreVuexModule, store);
    this.attributeImageUrl = storeModule.attributeImageUrl;
  }

  private onSelect() {
    if (this.selected.id) {
      eventBus.$emit('track', 'SelectAttribute', this.selected);
      this.$emit('selectAttribute', this.selected);
    }
  }

  private activate(el: AttributeModel) {
    if (this.selected === el) {
      this.selected = new AttributeModel();
    } else {
      this.selected = el;
    }

    this.onSelect();
  }

  private handleResize() {
    this.windowWidth = window.innerWidth;
  }
}
